import { slugs } from '@/constants/slugs'

export const TRAILER_EXPERIMENTS = {
  [slugs.theLastRodeo]: {
    'video-2': 'i-25KRuJmRQ',
    'video-3': 'q6NW2Cj8ZqI',
    'video-4': '3RVDGCcu25Q',
    default: '8dC_GBIosa4',
  },
} as const

export const getTrailerExperimentValue = (theatricalSlug: string, experimentValue: string): string => {
  const experiments = TRAILER_EXPERIMENTS[theatricalSlug]
  if (!experiments) return ''

  if (theatricalSlug === slugs.theLastRodeo) {
    return experiments[experimentValue as keyof typeof experiments] || experiments.default
  }

  return ''
}
